module.exports = __webpack_public_path__ + "img/olga-vk.c57535fc.jpg";